import * as React from 'react';
export var ItemLinkDataHooks;
(function (ItemLinkDataHooks) {
    ItemLinkDataHooks["Anchor"] = "ItemLinkDataHooks.Anchor";
})(ItemLinkDataHooks || (ItemLinkDataHooks = {}));
export var ItemLink = function (_a) {
    var onImageClick = _a.onImageClick, imageRef = _a.imageRef, children = _a.children;
    return (React.createElement("a", { href: imageRef, onClick: onImageClick, "data-hook": ItemLinkDataHooks.Anchor }, children));
};
//# sourceMappingURL=ItemLink.js.map